import { render, staticRenderFns } from "./NotificationsCall.vue?vue&type=template&id=6e8a6fec&scoped=true&"
import script from "./NotificationsCall.vue?vue&type=script&lang=js&"
export * from "./NotificationsCall.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsCall.vue?vue&type=style&index=0&id=6e8a6fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a6fec",
  null
  
)

export default component.exports